module.exports = __webpack_public_path__ + "static/portfolio-5-1906c7ee94736ec152c2b13ac4e47277.jpg";